import {
  DateOrNullOrUndefined,
  NumberOrNullOrUndefined,
  StringOrNullOrUndefined,
} from 'src/app/shared/utils';

export type ObjectiveStatus =
  | 'not started'
  | 'in progress'
  | 'mastered'
  | 'initiated'
  | 'on hold'
  | 'discontinued'
  | 'maintenance'
  | 'modified/revised';
export const OBJECTIVE_STATUS_MAP: Record<ObjectiveStatus, string> = {
  'not started': 'Not Started',
  'in progress': 'In Progress',
  mastered: 'Mastered',
  initiated: 'Initiated',
  'on hold': 'On Hold',
  discontinued: 'Discontinued',
  maintenance: 'Maintenance',
  'modified/revised': 'Modified/Revised',
};
export type ObjectiveType = 'STO' | 'LTO';
export class Objective {
  id: number = 0;
  plan_id: number = 0;
  type: ObjectiveType = 'STO';
  status: ObjectiveStatus = 'not started';
  name?: string;
  description: string = '';
  start_point: number = 0;
  target: number = 0;
  initial_date?: Date | null;
  end_date?: Date | null;
  created_at?: Date;
  updated_at?: Date;
  deleted_at?: Date;
  order?: number;
  index?: number;
  weeks_to_complete?: number;
  comparison_operator?: string;
  constructor(data: Partial<Objective> = {}) {
    this.id = NumberOrNullOrUndefined(data.id) ?? 0;
    this.plan_id = NumberOrNullOrUndefined(data.plan_id) ?? 0;
    this.status =
      (StringOrNullOrUndefined(data.status) as ObjectiveStatus) ||
      'not started';
    this.type = (StringOrNullOrUndefined(data.type) as ObjectiveType | undefined) ?? 'STO';
    // Permitir que initial_date y end_date sean null cuando vienen del servidor
    this.initial_date = DateOrNullOrUndefined(data.initial_date) ?? null;
    this.end_date = DateOrNullOrUndefined(data.end_date) ?? null;
    this.name = StringOrNullOrUndefined(data.name);
    this.description = StringOrNullOrUndefined(data.description) ?? '';
    this.target = NumberOrNullOrUndefined(data.target) ?? 0;
    this.start_point = NumberOrNullOrUndefined(data.start_point) ?? 0;
    this.order = NumberOrNullOrUndefined(data.order);
    this.index = NumberOrNullOrUndefined(data.index);
    this.weeks_to_complete = NumberOrNullOrUndefined(data.weeks_to_complete);
    this.comparison_operator = StringOrNullOrUndefined(data.comparison_operator);
    this.created_at = data.created_at ? new Date(data.created_at) : undefined;
    this.updated_at = data.updated_at ? new Date(data.updated_at) : undefined;
    this.deleted_at = data.deleted_at ? new Date(data.deleted_at) : undefined;
  }
  static getDefault(): Objective {
    return new Objective({
      id: 0,
      type: 'STO',
      plan_id: 0,
      status: 'not started',
      initial_date: null,
      end_date: null,
      description: '',
      target: 0,
      start_point: 0,
      order: 1,
      index: undefined,
      weeks_to_complete: undefined,
      comparison_operator: undefined,
    });
  }
  static getDefaultCaregiverObjectives(): Objective[] {
    return [
      {
        id: 0,
        plan_id: 0,
        type: 'STO' as const,
        status: 'not started' as const,
        initial_date: new Date(),
        end_date: null,
        name: 'Caregiver demonstrate understanding of the 4 functions of behavior',
        description:
          'Monthly fidelity checks in which the percentage of times (across 4 data points) the parent demonstrated concept.',
        target: 0,
        start_point: 0,
        order: 1,
        index: 0,
      },

      {
        id: 0,
        plan_id: 0,
        type: 'STO' as const,
        status: 'not started' as const,
        initial_date: new Date(),
        end_date: null,
        name: `
Caregiver demonstrate
understanding of
Reinforcement
`,
        description: `
Monthly fidelity checks in which the
percentage of times (across 4 data
points) the parent demonstrated
concept.
`,

        target: 0,
        start_point: 0,
        order: 1,
        index: 0,
      },
      {
        id: 0,
        plan_id: 0,
        type: 'STO' as const,
        status: 'not started' as const,
        initial_date: new Date(),
        end_date: null,
        name: `
Caregiver demonstrate
understanding of extinction
`,
        description: `
Monthly fidelity checks in which the
percentage of times (across 4 data
points) the parent demonstrated
concept.
`,

        target: 0,
        start_point: 0,
        order: 1,
        index: 0,
      },
      {
        id: 0,
        plan_id: 0,
        type: 'STO' as const,
        status: 'not started' as const,
        initial_date: new Date(),
        end_date: null,
        name: `
Caregiver demonstrate
understanding of Differential
Reinforcement
`,
        description: `
Monthly fidelity checks in which the
percentage of times (across 4 data
points) the parent demonstrated
concept.

`,

        target: 0,
        start_point: 0,
        order: 1,
        index: 0,
      },
      {
        id: 0,
        plan_id: 0,
        type: 'STO' as const,
        status: 'not started' as const,
        initial_date: new Date(),
        end_date: null,
        name: `
Caregiver demonstrate
understanding of Motivating
operations
`,
        description: `
Monthly fidelity checks in which the
percentage of times (across 4 data
points) the parent demonstrated
concept.
`,
        target: 0,
        start_point: 0,
        order: 1,
        index: 0,
      },
      {
        id: 0,
        plan_id: 0,
        type: 'STO' as const,
        status: 'not started' as const,
        initial_date: new Date(),
        end_date: null,
        name: `
Caregiver demonstrate
understanding of Prompting
`,
        description: `
Monthly fidelity checks in which the
percentage of times (across 4 data
points) the parent demonstrated
concept.

`,

        target: 0,
        start_point: 0,
        order: 1,
        index: 0,
      },
      {
        id: 0,
        plan_id: 0,
        type: 'STO' as const,
        status: 'not started' as const,
        initial_date: new Date(),
        end_date: null,
        name: `
Caregiver demonstrate
understanding of fading
`,
        description: `
Monthly fidelity checks in which the
percentage of times (across 4 data
points) the parent demonstrated
concept.

`,

        target: 0,
        start_point: 0,
        order: 1,
        index: 0,
      },
      {
        id: 0,
        plan_id: 0,
        type: 'STO' as const,
        status: 'not started' as const,
        initial_date: new Date(),
        end_date: null,
        name: `
Caregiver demonstrate
understanding of shaping
`,
        description: `
Monthly fidelity checks in which the
percentage of times (across 4 data
points) the parent demonstrated
concept.

`,

        target: 0,
        start_point: 0,
        order: 1,
        index: 0,
      },
      {
        id: 0,
        plan_id: 0,
        type: 'STO' as const,
        status: 'not started' as const,
        initial_date: new Date(),
        end_date: null,
        name: `
Caregiver demonstrate
understanding of antecedents
`,
        description: `
Monthly fidelity checks in which the
percentage of times (across 4 data
points) the parent demonstrated
concept.
`,

        target: 0,
        start_point: 0,
        order: 1,
        index: 0,
      },
      {
        id: 0,
        plan_id: 0,
        type: 'STO' as const,
        status: 'not started' as const,
        initial_date: new Date(),
        end_date: null,
        name: `
Caregiver demonstrate
understanding of
consequences
`,
        description: `
Monthly fidelity checks in which the
percentage of times (across 4 data
points) the parent demonstrated
concept.
`,

        target: 0,
        start_point: 0,
        order: 1,
        index: 0,
      },
      {
        id: 0,
        plan_id: 0,
        type: 'STO' as const,
        status: 'not started' as const,
        initial_date: new Date(),
        end_date: null,
        name: `
Caregiver demonstrate
understanding of task
analysis
`,
        description: `
Monthly fidelity checks in which the
percentage of times (across 4 data
points) the parent demonstrated
concept.
`,

        target: 0,
        start_point: 0,
        order: 1,
        index: 0,
      },
      {
        id: 0,
        plan_id: 0,
        type: 'STO' as const,
        status: 'not started' as const,
        initial_date: new Date(),
        end_date: null,
        name: `
Caregiver demonstrate
understanding of chaining
`,
        description: `
Monthly fidelity checks in which the
percentage of times (across 4 data
points) the parent demonstrated
concept.
`,

        target: 0,
        start_point: 0,
        order: 1,
        index: 0,
      },
      {
        id: 0,
        plan_id: 0,
        type: 'STO' as const,
        status: 'not started' as const,
        initial_date: new Date(),
        end_date: null,
        name: `
Caregiver demonstrate
generalization of skills to
natural environment
`,
        description: `
Monthly fidelity checks in which the
percentage of times (across 4 data
points) the parent demonstrated concept.
      `,
        target: 0,
        start_point: 0,
        order: 1,
        index: 0,
      },
    ].map((_, index) => ({ ..._, index }));
  }
}
